import * as customApiErrors from '@/lib/custom-api-errors';
import {
  CustomApiError,
  type NamedApiErrorInit,
} from '@/lib/custom-api-errors';
import { SERVER_ERROR_CODES } from '~/generated/server-error-codes';

type ApiErrorPayload = {
  statusCode?: number | null;
  msg?: string | null;
  msgArgs?: string[] | null;
};

const namedErrorClasses = Object.values(customApiErrors).filter(
  (value): value is typeof CustomApiError =>
    typeof value === 'function' && value.prototype instanceof CustomApiError,
);

const ERROR_BY_STATUS_CODE = new Map<number, typeof CustomApiError>(
  namedErrorClasses.map((ErrorClass) => [
    new ErrorClass().statusCode,
    ErrorClass,
  ]),
);

export const createApiError = (payload: ApiErrorPayload): CustomApiError => {
  const statusCode = payload.statusCode ?? SERVER_ERROR_CODES.COMMON_ERROR;
  const init: NamedApiErrorInit = {
    msg: payload.msg ?? undefined,
    msgArgs: payload.msgArgs ?? [],
  };

  const ErrorClass = ERROR_BY_STATUS_CODE.get(statusCode);

  return ErrorClass
    ? new ErrorClass(init)
    : new CustomApiError({ ...init, statusCode });
};
